export const PackQuantityConstant: number[] = [5, 10, 20];
